import type { SpaceBackground } from '../types/spaces';
import { defaultProceduralBackground } from '../components/Space/backgrounds/proceduralRegistry';

/**
 * Default background for newly created spaces (backend default).
 * Must match `DEFAULT_SPACE_BACKGROUND_PRESET` in `backend/config/constants.py`
 * and the `bgN` preset classes (App.scss `--bg-N`, GUILayout).
 *
 * Product name for preset 1: "River Valley" (Space → Background in the app).
 */
export const DEFAULT_NEW_SPACE_BACKGROUND_PRESET_ID = 'bg1' as const;

/** Human-readable name for the default preset (Space → Background swatch tooltip). */
export const DEFAULT_NEW_SPACE_BACKGROUND_PRESET_LABEL = 'River Valley';

export const DEFAULT_NEW_SPACE_BACKGROUND: SpaceBackground = {
  type: 'preset',
  value: DEFAULT_NEW_SPACE_BACKGROUND_PRESET_ID,
};

/**
 * The default background applied to new desktops — a calm blue procedural
 * contour map. When a space still has the untouched backend default (bg1
 * preset or no background), the desktop normalizes it to this on first open.
 */
export const DEFAULT_DESKTOP_BACKGROUND: SpaceBackground = defaultProceduralBackground('contours');

/**
 * Returns true when a space's background has never been deliberately chosen —
 * i.e. it is still the backend-assigned default (bg1 preset) or absent entirely.
 * Used to decide whether to normalize to the default desktop background on first open.
 */
export function isUntouchedDefaultBackground(bg?: SpaceBackground | null): boolean {
  if (!bg) return true;
  return bg.type === 'preset' && bg.value === DEFAULT_NEW_SPACE_BACKGROUND_PRESET_ID;
}
